import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=ac956908&scoped=true&"
import script from "./Robot.vue?vue&type=script&lang=js&"
export * from "./Robot.vue?vue&type=script&lang=js&"
import style0 from "./Robot.vue?vue&type=style&index=0&id=ac956908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac956908",
  null
  
)

export default component.exports